import { VerificationStatus } from '../modules/Verification/lib/steps/types';

// It ranks all the verification statuses, in order of importance
const STATUS_IMPORTANCE: Record<VerificationStatus, number> = {
  [VerificationStatus.Invalid]: 4,
  [VerificationStatus.ToDo]: 3,
  [VerificationStatus.Completed]: 2,
  [VerificationStatus.Validated]: 1,
  [VerificationStatus.Irrelevant]: 0,
};

/**
 * Computes the status of a module composed of multiple sub-modules
 */
const computeModuleStatusFromSubStatuses = (
  moduleStatuses: VerificationStatus[],
): VerificationStatus =>
  moduleStatuses.reduce(
    (acc, status) =>
      STATUS_IMPORTANCE[status] > STATUS_IMPORTANCE[acc] ? status : acc,
    VerificationStatus.Irrelevant,
  );

export { computeModuleStatusFromSubStatuses };
